import { SvgIcon } from '@mui/material';
import { FC } from 'react';

const Close: FC = () => (
  <SvgIcon fontSize="inherit">
    <svg fill="none" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        // eslint-disable-next-line max-len
        d="m23.365 4.6714c-0.61028-0.7685-3.4017-3.56-4.1702-4.1815-2.4637 1.9778-4.8596 4.0572-7.1877 6.2384-2.3281-2.1812-4.724-4.2606-7.1877-6.2384-0.7685 0.62158-3.56 3.413-4.1702 4.1815 1.9665 2.4524 4.0459 4.8483 6.2271 7.1764-2.2829 2.4185-4.4528 4.9048-6.5096 7.4703 0.62158 0.7685 3.413 3.56 4.1815 4.1815 2.5541-2.0569 5.0517-4.2267 7.459-6.4983 2.4185 2.2829 4.9048 4.4415 7.459 6.4983 0.7685-0.61028 3.5713-3.413 4.1815-4.1815-2.0569-2.5654-4.2267-5.0517-6.5096-7.4703 2.1812-2.3281 4.2606-4.724 6.2271-7.1764z"
        fill="currentColor"
        strokeWidth="1.1301"
      />
    </svg>
  </SvgIcon>
);

export default Close;
